<app-header login='yes'></app-header>

<div class="container-fluid">
    <div class="responsive mt-4">
        <div class="row margin-b">

            <div class="col-md-12 col-xs-12">
                <div class="d-flex justify-content-between">
                    <div class="display">
                        <div class="margin-l">
                            <div class="display">
                                <form class="form-inline">
                                    <div>
                                        <input class="form-control mr-sm-2 mb-1" #inputSearch type="search"
                                            placeholder="Name" aria-label="Search">
                                        <br>
                                        <input class="form-control mr-sm-2" #inputLocation type="search"
                                            placeholder="Location/ Zip Code" aria-label="Search">
                                    </div>
                                    <div>
                                        <button class="btn mb-1 w-100 main-backgroundcolor color cursor"
                                            (click)="removeFilters()">Clear Filters</button>
                                        <br>
                                        <button class="btn w-100 main-backgroundcolor color my-2 my-sm-0"
                                            type="submit">Search</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="margin-l">
                            <p class="mx-0 my-0 searchh text-center">Advanced <br>
                                Search</p>
                            <span routerLink="/claim-list/filter">
                                <i class="fas fa-sliders-h cursor"></i>
                            </span>
                        </div>
                    </div>
                    <div class="create-profile">
                        <p class="my-0">Can't Find Your Ministry?</p>
                        <button type="button" (click)="openSignUpPage()" class="btn main-backgroundcolor w-100 text-white mt-2 btn-lg btnn">Create Ministry Profile</button>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-12 col-xs-12">
                <app-no-results-found *ngIf="objArr.length == 0 && loading" title='Claim List'></app-no-results-found>
                <div *ngIf="!loading">
                    <div *ngFor="let props of arr">
                        <app-card-skelton></app-card-skelton>
                    </div>
                </div>
                <div *ngIf="loading">
                    <div *ngFor="let props of (objArr | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: pageNo,
                    totalItems: totalItems
                  })">
                        <app-alert-card size=2 [showtext]=true [data]="props" title="Claim" [others]="true"
                            [route]="route">
                        </app-alert-card>
                    </div>
                </div>
                <div *ngIf="objArr.length > 2" class="col-md-12" style="text-align: center;">

                    <!-- <app-pagination [maxSize]="pageSize" (pageChange)="page = onChange($event)"></app-pagination> -->
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="objArr?.length > 0 "
                        (pageChange)="page = setPagination($event)" directionLinks="true" autoHide="false"
                        responsive="true" previousLabel="Previous" nextLabel="Next"
                        screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>



            </div>
        </div>
    </div>

</div>